
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*
const app = new Vue({
    el: '#app'
});
*/

//fészek
$(document).ready(function(){
    $('header #carouselHero .carousel-item').css('height', $(window).height());

    $("header .nav .trigger").click(function(){
        $('.nav-menu').slideToggle( "slow", function() {
            //...
        });
    });

    $("header .nav-mobile .trigger").click(function(){
        $('.nav-menu-mobile').slideToggle( "slow", function() {
            //...
        });
    });

    var header = $('header').height();
    var block = $('.why-pecs').height();

    //$('#szechenyi-img').height(header + block + 128);

    if( window.scrollY===0 ){
        $('#nav-scroll').show();
    }
    else{
        $('#nav-scroll').hide();
    }
});

$(window).resize(function(){
    $('header #carouselHero .carousel-item').css('height', $(window).height());
});

$(window).scroll(function(){
    if( window.scrollY===0 ){
        $('#nav-scroll').show();
    }
    else{
        $('#nav-scroll').hide();
    }
});